export default __webpack_public_path__ + "static/media/icon-content-active.c3a40100.svg";